import React from "react";

export const Close = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 47.971 47.971"
    version="1.1"
    viewBox="0 0 47.971 47.971"
    xmlSpace="preserve"
  >
    <path d="M28.228 23.986L47.092 5.122a2.998 2.998 0 000-4.242 2.998 2.998 0 00-4.242 0L23.986 19.744 5.121.88a2.998 2.998 0 00-4.242 0 2.998 2.998 0 000 4.242l18.865 18.864L.879 42.85a2.998 2.998 0 104.242 4.241l18.865-18.864L42.85 47.091c.586.586 1.354.879 2.121.879s1.535-.293 2.121-.879a2.998 2.998 0 000-4.242L28.228 23.986z" />
  </svg>
);

export const Error = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 51.976 51.976"
    version="1.1"
    viewBox="0 0 51.976 51.976"
    xmlSpace="preserve"
  >
    <path d="M44.373 7.603c-10.137-10.137-26.632-10.138-36.77 0-10.138 10.138-10.137 26.632 0 36.77s26.632 10.138 36.77 0c10.137-10.138 10.137-26.633 0-36.77zm-8.132 28.638a2 2 0 01-2.828 0l-7.425-7.425-7.778 7.778a2 2 0 11-2.828-2.828l7.778-7.778-7.425-7.425a2 2 0 112.828-2.828l7.425 7.425 7.071-7.071a2 2 0 112.828 2.828l-7.071 7.071 7.425 7.425a2 2 0 010 2.828z" />
  </svg>
);

export const Info = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 512 512"
    version="1.1"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
  >
    <path d="M256 0C114.511 0 0 114.496 0 256c0 141.489 114.496 256 256 256 141.489 0 256-114.496 256-256C512 114.511 397.504 0 256 0zm17.86 367.926c0 9.864-7.997 17.86-17.86 17.86s-17.86-7.997-17.86-17.86V221.47c0-9.864 7.997-17.86 17.86-17.86s17.86 7.997 17.86 17.86v146.456zm0-202.419c0 9.864-7.997 17.86-17.86 17.86s-17.86-7.997-17.86-17.86v-21.433c0-9.864 7.997-17.86 17.86-17.86s17.86 7.997 17.86 17.86v21.433z" />
  </svg>
);

export const Warning = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 485.811 485.811"
    version="1.1"
    viewBox="0 0 485.811 485.811"
    xmlSpace="preserve"
  >
    <path d="M476.099 353.968l-170.2-294.8c-27.8-48.7-98.1-48.7-125.8 0l-170.3 294.8c-27.8 48.7 6.8 109.2 62.9 109.2h339.9c56.1 0 91.3-61.1 63.5-109.2zm-233.2 43.8c-14.8 0-27.1-12.3-27.1-27.1s12.3-27.1 27.1-27.1 27.1 12.3 26.5 27.8c.7 14.1-12.3 26.4-26.5 26.4zm24.7-175.2c-1.2 21-2.5 41.9-3.7 62.9-.6 6.8-.6 13-.6 19.7-.6 11.1-9.3 19.7-20.4 19.7s-19.7-8-20.4-19.1c-1.8-32.7-3.7-64.8-5.5-97.5-.6-8.6-1.2-17.3-1.9-25.9 0-14.2 8-25.9 21-29.6 13-3.1 25.9 3.1 31.5 15.4 1.9 4.3 2.5 8.6 2.5 13.6-.6 13.7-1.9 27.3-2.5 40.8z" />
  </svg>
);

export const Success = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 52 52"
    version="1.1"
    viewBox="0 0 52 52"
    xmlSpace="preserve"
  >
    <path d="M26 0C11.664 0 0 11.663 0 26s11.664 26 26 26 26-11.663 26-26S40.336 0 26 0zm14.495 17.329l-16 18a1.997 1.997 0 01-2.745.233l-10-8a2 2 0 012.499-3.124l8.517 6.813L37.505 14.67a2.001 2.001 0 012.99 2.659z" />
  </svg>
);
